module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/092-sierra-leone-7decb15a45e4744ac683ad09ab70a0c0.svg";